// Interface translations
import englishMessages from 'i18n/aor/en';
import dutchMessages from 'aor-language-dutch';
import frenchMessages from 'aor-language-french';
import germanMessages from 'aor-language-german';
import italianMessages from 'aor-language-italian';
import spanishMessages from 'aor-language-spanish';

// Domain translations
import { default as domainMessages } from 'i18n';

const messages = {
    de: { ...germanMessages, ...domainMessages.de },
    en: { ...englishMessages, ...domainMessages.en },
    es: { ...spanishMessages, ...domainMessages.es },
    fr: { ...frenchMessages, ...domainMessages.fr },
    it: { ...italianMessages, ...domainMessages.it },
    nl: { ...dutchMessages, ...domainMessages.nl },
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/messages.js